export default __webpack_public_path__ + "static/media/ic_x.66044891.svg";